import { useEffect } from "react";
import "@/App.css";
import axios from "axios";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import ServicesMarquee from "@/components/ServicesMarquee";
import Services from "@/components/Services";
import Founder from "@/components/Founder";
import Certificates from "@/components/Certificates";
import Coaching from "@/components/Coaching";
import SuccessStories from "@/components/SuccessStories";
import Proof from "@/components/Proof";
import Resources from "@/components/Resources";
import TaxChecklist from "@/components/TaxChecklist";
import FAQ from "@/components/FAQ";
import Pricing from "@/components/Pricing";
import CoachingJourney from "@/components/CoachingJourney";
import Booking from "@/components/Booking";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import AdminDashboard from "@/pages/AdminDashboard";
import CFOAccelerator from "@/pages/CFOAccelerator";
import PayInstalment from "@/pages/PayInstalment";
import ThankYou from "@/pages/ThankYou";
import ReferFriend from "@/components/ReferFriend";
import ReferralBanner from "@/components/ReferralBanner";

const refParam = new URLSearchParams(window.location.search).get("ref");
if (refParam) localStorage.setItem("bc_ref_code", refParam.toUpperCase());

function Home() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    if (!sessionStorage.getItem("bc_visit_tracked")) {
      axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/track`, { page: "home" }).catch(() => {});
      sessionStorage.setItem("bc_visit_tracked", "1");
    }
  }, []);

  return (
    <>
      <Nav />
      <main>
        <Hero />
        <ServicesMarquee />
        <Services />
        <Founder />
        <Certificates />
        <Coaching />
        <SuccessStories />
        <Proof />
        <Resources />
        <TaxChecklist />
        <Pricing />
        <CoachingJourney />
        <FAQ />
        <Booking />
        <Contact />
        <ReferFriend />
      </main>
      <Footer />
      <ReferralBanner />
    </>
  );
}

function App() {
  return (
    <div className="App bg-bone text-pine">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/cfo-accelerator" element={<CFOAccelerator />} />
          <Route path="/pay/:planId" element={<PayInstalment />} />
          <Route path="/thank-you" element={<ThankYou />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
